import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQuery } from './basequery';

export const modelEngineService = createApi({
  reducerPath: "modelEngineApi",
  baseQuery: baseQuery,
  refetchOnFocus: true,
  refetchOnReconnect: true,
  refetchOnMountOrArgChange: true,
  endpoints: (build) => ({
    quickPredicts: build.mutation({
      query: ({ appId, ...values }) => ({
        url: `/models/quickpredict/${appId}`,
        method: "post",
        data: { ...values },
      }),
    }),

    exportModel: build.mutation({
      query: ({ ...values }) => ({
        url: `/models/deploy/`,
        method: "post",
        data: { ...values },
      }),
    }),
  }),
});


export const { useQuickPredictsMutation, useExportModelMutation } = modelEngineService;